import {
    DEVICES_BULK_ACTIONS_OPEN_MODAL,
    DEVICES_BULK_ACTIONS_CLOSE_MODAL,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT,
    DEVICES_BULK_ACTIONS_REQUEST,
    DEVICES_BULK_ACTIONS_RESULT,
    DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT,
    DEVICES_BULK_SEND_MESSAGE_REQUEST,
    DEVICES_BULK_SEND_MESSAGE_RESULT,
    DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST,
    DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT,
} from "Redux/actionTypes";

export const bulkActionsSendMessageRequest = (data) => ({
    type: DEVICES_BULK_SEND_MESSAGE_REQUEST,
    payload: data
})

export const bulkActionsSendMessageResult = (result) => ({
    type: DEVICES_BULK_SEND_MESSAGE_RESULT,
    payload: result
})

export const bulkActionsSearchCommandsRequest = (data) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST,
    payload: data
})

export const bulkActionsSearchCommandsResult = (result) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT,
    payload: result
})


export const bulkActionsOpenModal = (data) => ({
    type: DEVICES_BULK_ACTIONS_OPEN_MODAL,
    payload: data
})

export const bulkActionsCloseModal = () => ({
    type: DEVICES_BULK_ACTIONS_CLOSE_MODAL
})

export const bulkActionsSearchDevicesRequest = (conditions) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST,
    payload: conditions
})

export const bulkActionsSearchDevicesResult = (result) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT,
    payload: result
})

export const bulkActionsSearchDeviceModelRequest = (name) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST,
    payload: { name }
})

export const bulkActionsSearchDeviceModelResult = (result) => ({
    type: DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT,
    payload: result
})

export const bulkActionsGetSupportedTimezonesRequest = () => ({
    type: DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST,
    payload: {  }
})

export const bulkActionsGetSupportedTimezonesResult = (result) => ({
    type: DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT,
    payload: result
})

export const bulkActionsRequest = (data) => ({
    type: DEVICES_BULK_ACTIONS_REQUEST,
    payload: data
})

export const bulkActionsResult = (result) => ({
    type: DEVICES_BULK_ACTIONS_RESULT,
    payload: result
})